import React, { Component } from 'react';

class Instrucoes extends Component {

    render() {
        return (<div>

            <div className="edb-center edb-margin-large-bottom">

                <div className="edb-text-bold edb-margin-top">INSTRUÇÕES</div>

                {this.props.semConsulta && <div className="edb-panel adap-light-yellow">
                    <p>
                        <strong>Atenção!</strong>
                        <br />
                        Seu simulado é sem consulta. Se você trocar de janela ou minimizar, seu simulado será finalizado.
                                </p>
                </div>}
                <p>
                    Este simulado é composto por <strong>{this.props.totalQuestoes} questões</strong>
                    {!this.props.tempoTotalMinutos && <span>.</span>}

                    {this.props.tempoTotalMinutos > 0 && <span>
                        &nbsp;e você tem <strong>{this.props.tempoTotalMinutos} minutos</strong> para concluir.
                                </span>}
                </p>
            </div>

            {/* ************ Explicações dos controles do simulado **************** */}
            <hr className="edb-hide-medium edb-hide-large " />
            <div className="edb-row edb-margin-bottom">
                <div className="edb-col m4 edb-padding edb-center">
                    {/* **** Controle **** */}
                    <div className="edb-row-cell edb-margin-small-top edb-inline">
                        <div className="edb-cell edb-cell-middle edb-padding-small">
                            <i className="edb-xlarge far fa-clock"></i>
                        </div>
                        <div className="edb-cell edb-left-align">
                            <div className="edb-small">Tempo restante:</div>
                            <div className="edb-small edb-text-bold">00:00</div>
                        </div>
                    </div>
                </div>
                <div className="edb-col m8 edb-padding-small edb-center-mobile">
                    {/* **** Explicação **** */}
                    Acima do simulado você tem o tempo restante para a sua prova.
                    {/* Para simulados sem restrição de tempo, esse controle não será exibido. */}
                </div>
            </div>

            <hr className="edb-hide-medium edb-hide-large " />
            <div className="edb-row  edb-margin-bottom">
                <div className="edb-col m4 edb-padding edb-center">
                    {/* **** Controle **** */}
                    <i className="fas fa-arrow-left edb-xlarge"></i>
                    <i className="fas fa-arrow-right  edb-margin-left edb-xlarge"></i>

                </div>
                <div className="edb-col m8 edb-padding-small edb-center-mobile">
                    {/* **** Explicação **** */}
                    Use as setas para trocar de questão.
                                </div>
            </div>

            <hr className="edb-hide-medium edb-hide-large " />
            <div className="edb-row edb-margin-bottom ">
                <div className="edb-col m4 edb-padding edb-center">
                    {/* **** Controle **** */}
                    <button className="edb-button edb-round adap-gray">Confirmar</button>

                </div>
                <div className="edb-col m8 edb-padding-small edb-center-mobile">
                    {/* **** Explicação **** */}
                    Use o botão confirmar para registrar a resposta da questão atual e passar para a próxima.
                                </div>
            </div>

            <hr className="edb-hide-medium edb-hide-large " />
            <div className="edb-row edb-margin-bottom ">
                <div className="edb-col m4 edb-padding edb-center">
                    {/* **** Controle **** */}
                    <button className="edb-button edb-round adap-gray">
                        <i className="edb-margin-small-right adap-text-darkgray fas fa-question-circle"></i>
                        Estou em dúvida
                                    </button>

                </div>
                <div className="edb-col m8 edb-padding-small edb-center-mobile">
                    {/* **** Explicação **** */}
                    Se quiser marcar uma questão temporariamente para rever e confirmar antes de encerrar o simulado, use o botão de dúvida.
                                </div>
            </div>

            <hr className="edb-hide-medium edb-hide-large " />
            <div className="edb-row edb-margin-bottom ">
                <div className="edb-col m4 edb-padding edb-center">
                    {/* **** Controle **** */}
                    <button className="edb-button edb-padding-small-mobile">
                        <i className="edb-large fas fa-question-circle"></i>
                        <i className="edb-large fas fa-chevron-right"></i>
                        <div className="edb-tiny edb-line-height-tiny ">PRÓXIMA <br /> DÚVIDA</div>
                    </button>
                    <button className="edb-button edb-padding-small-mobile">
                        <i className="edb-large far fa-circle"></i>
                        <i className="edb-large fas fa-chevron-right"></i>
                        <div className="edb-tiny edb-line-height-tiny">PRÓXIMA <br /> EM BRANCO</div>
                    </button>

                </div>
                <div className="edb-col m8 edb-padding-small edb-center-mobile">
                    {/* **** Explicação **** */}
                    Utilize os botões “próxima dúvida” e “próxima em branco” para pular as questões que já respondeu e ir direto para o que precisa ainda concluir.
                                </div>
            </div>
        </div>);
    }
}

export default Instrucoes;